import httpClient from '@/core/http/client.service';

class User {
  static getSession() {
    return httpClient
        .get('api/v1/user/info?_format=json');
  }

  static updateHospital(hospitalId) {
    const data = {};
    data.hospitalId = hospitalId;

    return httpClient
        .post('api/v1/user/info?_format=json', data);
  }

  static updateGaPermission(gaPermission) {
    const data = {};
    data.gaPermission = gaPermission;

    return httpClient
        .post('api/v1/user/info?_format=json', data);
  }
}

export default User;
